import { render } from "./Factoid.vue?vue&type=template&id=1caaf014&scoped=true"
import script from "./Factoid.vue?vue&type=script&lang=js"
export * from "./Factoid.vue?vue&type=script&lang=js"

import "./Factoid.vue?vue&type=style&index=0&id=1caaf014&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src3524514966/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1caaf014"]])

export default __exports__